import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { autoDismiss: { type: Number, default: 0 } };

  connect() {
    this.closeButton = this.element.querySelector(':scope > button');
    if (this.closeButton) {
      this.dismissHandler = () => this.dismiss();
      this.closeButton.addEventListener('click', this.dismissHandler);
    }
    if (this.autoDismissValue > 0) {
      this.timeout = setTimeout(() => this.dismiss(), this.autoDismissValue);
    }
  }

  disconnect() {
    clearTimeout(this.timeout);
    if (this.closeButton && this.dismissHandler) {
      this.closeButton.removeEventListener('click', this.dismissHandler);
    }
  }

  dismiss() {
    this.element.classList.add('transition-opacity', 'duration-300', 'opacity-0');
    setTimeout(() => this.element.remove(), 300);
  }
}
